import React, { useContext, useState } from 'react'
import { 
  Container,
  HeaderDiv,
  HeaderText
} from './style'
import StructureTable from './StructureTable'
import FileInputStructure from './FileInput'
import ParametersContext from '../../../../../contexts/ParametersContext'

interface StructureProp {
  index: number
}

const Structure: React.FC<StructureProp> = (props) => {
  const { structures } = useContext(ParametersContext)  

  return (
      <Container>
        <HeaderDiv>
          <HeaderText>{structures[props.index].name}</HeaderText>
        </HeaderDiv>
        {structures[props.index].hasTable && <StructureTable index={props.index}/>}
        {structures[props.index].fileImport && <FileInputStructure/>}
      </Container>
  )
}
export default Structure
